module.exports = __webpack_public_path__ + "static/media/ag-staffLR2.4653f2e0.jpg";